import { useCore } from '$api-clients/hooks';

export function useGetOffer(offerId: string | null, skip = false) {
  const shouldSkip = !offerId || skip;

  const { data, error, isLoading } = useCore(
    '/offers/{offerId}',
    shouldSkip
      ? null
      : {
          params: {
            path: {
              offerId,
            },
          },
        },
  );

  return {
    offer: data,
    error,
    isLoading,
  };
}
